import { useState } from 'react';
import Sidebar from './Sidebar';
import { Route, Switch } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoggedUserCard from './LoggedUserCard';
import Products from '../modules/Inventory/Products';
import Utilisateurs from '../modules/Users/Utilisateurs';
import SnackbarNotification from '../components/SnackbarNotification';
import Zones from '../modules/Inventory/Zones';
import Inventaires from '../modules/Inventory/Inventaires';
import ZoneDetails from '../modules/Inventory/ZoneDetails';
import Emplacements from '../modules/Inventory/Emplacements';
import Depots from '../modules/Inventory/Depots';
import RapportEcarts from '../modules/Inventory/RapportEcarts';
import RapportZones from '../modules/Inventory/RapportZones';
import Dashboard from '../modules/Inventory/Dashboard';
import RapportZonesDetails from '../modules/Inventory/RapportZonesDetails';

const Layout = () => {
  const layoutStyle = {
    display: 'flex',
    height: '100vh',
    overflowX: 'hidden',
  };

  const blurStyle = {
    position: 'absolute',
    width: '100%',
    height: '150px',
    background: '#6379F5',
    opacity: 0.15,
    filter: 'blur(50px)',
    zIndex: 0,
  };

const headerStyle = {
  display: 'flex',
  alignItems: 'center',     
  justifyContent: 'flex-end',
  width: '100%',
  padding: '20px 40px',
  gap: '10px',
  zIndex: 1000,
  position: 'sticky',
};


  const contentStyle = {
    padding: '20px 40px 20px 40px',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    position: 'relative',
    maxWidth: '100vw',
  };

  const history = useHistory();
  const location = useLocation();

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const showSnackbar = (message, severity = 'success', manual = false) => {
    setSnackbar({ open: true, message, severity, manual });
  };

  useEffect(() => {
    if (location.state?.showSnackbar) {
      showSnackbar(location.state.snackbarMessage, location.state.snackbarSeverity);
      history.replace({ ...location, state: undefined });
    }
  }, [location, history]);


  return (
    <div style={layoutStyle}>
      <div style={blurStyle}></div>
      <div className="absolute bottom-0 left-20 h-full w-1/2 bg-cover bg-center  z-[-100]"
        style={{ backgroundImage: `url(${require('../images/background.png')})`, backgroundSize: "cover", backgroundPosition: "center" }}>
      </div>
      <div style={{
        flex: '0 0 auto',
        width: '25%',
        minWidth: '220px',
        maxWidth: '270px'
      }}>        
      <Sidebar />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflowX: 'hidden' }}>
        <div style={headerStyle}>
          <LoggedUserCard />
        </div>
        {/* Content */}
        <div style={contentStyle}>
          <Switch>
            {/* Grayfox inventory menu items */}
            <Route path="/produits" component={Products} exact />
            <Route path="/" component={Depots} exact />
          <Route path="/dashboard" component={Dashboard} exact />
         
 <Route path="/rapport-ecarts" component={RapportEcarts} exact />
 <Route path="/rapport-zones/details/:id" component={RapportZonesDetails} exact />
 <Route path="/rapport-zones" component={RapportZones} exact />
 <Route path="/inventaires" component={Inventaires} exact />
            <Route path="/zones/details/:id" component={ZoneDetails} exact />
            <Route path="/zones" component={Zones} exact />
            <Route path="/emplacements" component={Emplacements} exact />
            <Route path="/utilisateurs" component={Utilisateurs} exact />

          </Switch>
        </div>
      </div>

      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        manual={snackbar.manual}
      />
    </div>
  );
};

export default Layout;
